export default function getAddressComponentByType(addressComponents, type) {
  for (let i = 0; i < addressComponents.length; i++) {
    const component = addressComponents[i];
    const types = component.types || [];
    if (types.includes(type)) {
      return component;
    }
  }
  return null;
}
